import React from "react";
import { ShieldAlert, CheckCircle2, AlertTriangle } from "lucide-react";

// Single combined "what BotChainCP is" + disclaimer block. Rendered on the public
// Landing page and (per user request) on the post-login Dashboard.
export default function WhatIsBotChainCP({ className = "" }) {
  return (
    <div className={`glass-strong p-7 md:p-9 ${className}`} data-testid="what-is-botchaincp">
      <div className="flex flex-wrap items-center gap-3 mb-5">
        <span className="chip chip-blue">What is BotChainCP</span>
        <span className="chip chip-amber flex items-center gap-1.5"><ShieldAlert size={12} /> Disclaimer</span>
      </div>
      <h2 className="font-display text-2xl md:text-3xl font-semibold tracking-tight mb-4">
        An independent tracking &amp; forecasting dashboard for CaryPact participants.
      </h2>
      <p className="text-ink-2 leading-relaxed max-w-3xl mb-6 text-sm">
        BotChainCP is a dashboard we built to keep our own CaryPact participation honest — track every wallet, log every
        stake, watch every withdrawal, and forecast what the position looks like under real risk scenarios. It is
        independent of and not affiliated with CaryPact, BOT Chain, or Coinstore. We don&apos;t custody, pool, or invest
        your funds. We don&apos;t promise returns. We don&apos;t provide financial, legal, or tax advice.
      </p>
      <div className="grid md:grid-cols-2 gap-6 pt-5" style={{ borderTop: "1px solid rgba(15,18,38,0.08)" }}>
        <div>
          <div className="text-[11px] font-bold uppercase tracking-widest text-ink-3 mb-2.5">What it does</div>
          <ul className="space-y-2 text-sm text-ink-2">
            {[
              "Personal CA wallet & mining tracker",
              "Flexible + fixed-term staking ledger",
              "Withdrawal & USDT recovery tracker",
              "Forecast tool with downside scenarios",
              "Risk alerts & affiliate activity",
            ].map((t) => (
              <li key={t} className="flex items-center gap-2"><CheckCircle2 size={16} style={{ color: "#00C853" }} className="flex-shrink-0" /> {t}</li>
            ))}
          </ul>
        </div>
        <div>
          <div className="text-[11px] font-bold uppercase tracking-widest text-ink-3 mb-2.5">What it does not do</div>
          <ul className="space-y-2 text-sm text-ink-2">
            {[
              "Does not custody, pool or invest funds",
              "Does not promise returns or guarantees",
              "Not a fixed-income or passive-income product",
              "Does not sign or execute trades for you",
              "Does not provide financial advice",
            ].map((t) => (
              <li key={t} className="flex items-center gap-2"><AlertTriangle size={16} style={{ color: "#B45309" }} className="flex-shrink-0" /> {t}</li>
            ))}
          </ul>
        </div>
      </div>
      <p className="text-[11px] text-ink-3 mt-6 leading-relaxed max-w-3xl">
        CaryPact participation involves risk including loss of principal. CA token price and liquidity can fluctuate.
        Withdrawals may fail or be delayed. Past performance does not guarantee future results. Tax obligations are yours.
      </p>
    </div>
  );
}
